import styled from "styled-components";

export const CategoryContainer = styled.div`
  padding-top: 20px;

  img {
    border-radius: 6px;
    display: inline;
  }

  .slick-slide {
    padding-right: 8px;
  }
`;
